export const openWhatsApp = (message = "Olá, Pontes Tecnologia e Inovação.") => {
  const encoded = encodeURIComponent(message);
  const phone = "5518998174736";
  window.open(`https://wa.me/${phone}?text=${encoded}`, "_blank");
};